import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'vc-toggle',
    templateUrl: './toggle.component.html',
    styleUrls: ['./toggle.component.scss'],
})
export class ToggleComponent<T> {
    /** Whether toggle is checked or not.  Defaults to false. */
    @Input()
    checked: boolean = false;

    /** Whether the label should appear after or before the slide-toggle. Defaults to 'after'. */
    @Input()
    label!: string;

    /** Whether the description should appear to the slide-toggle */
    @Input()
    description!: string;

    /** Whether the label should appear after or before the slide-toggle. Defaults to 'after'. */
    @Input()
    labelPosition: 'after' | 'before' = 'after';

    /** Whether the component is disabled */
    @Input()
    disabled: boolean = false;

    /** A unique id for the checkbox input. If none is supplied, it will be auto-generated. */
    @Input()
    id!: string;

    /** The 'aria-describedby' attribute is read after the element's label and field type. */
    @Input()
    ariaDescribedby!: string;

    /** Attached to the aria-label attribute of the host element. In most cases, aria-labelledby will take precedence so this may be omitted. */
    @Input()
    ariaLabel?: string;

    /** Used to set the aria-labelledby attribute on the underlying input element. */
    @Input('aria-labelledby')
    ariaLabelledby!: string | null;

    /** Emits the value of the toggle whenever it changes  */
    @Output()
    checkedChange = new EventEmitter<boolean>();
}
